import React, { Component } from "react";
import { Container, Grid } from "@material-ui/core";
import RtiDescription from "./RtiDescription";
import "./rti.css";

const list = [
  { title: "RTI", link: "/rti/home", gr: "home" },
  { title: "RTI Officers", link: "/rti/officers", gr: "officers" },
  // { title: "Information in Electronic Form", link: "/rti/ief", gr: "ief" },
  // { title: "Particulars available to the Citizens", link: "/rti/pac", gr: "pac" },
];

class RtiContainer extends Component {
  state = {
    link: "",
  };

  componentDidMount() {
    this.setState({ link: this.props.match.params.link });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.link !== this.props.match.params.link) {
      this.setState({ link: this.props.match.params.link });
    }
  }

  render() {
    return (
      <div className="rti-wrap">
        <Container>
          <Grid container spacing={4}>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <nav className="rti-side">
                <div className="rti-side-head">Right to Information</div>
                <ul className="rti-side-list">
                  {list.map((el, index) => (
                    <li
                      key={index}
                      className={`rti-side-item${
                        el.gr === this.state.link ? " active" : ""
                      }`}
                      onClick={() => this.props.history.push(el.link)}
                    >
                      <span className="rti-dot" />
                      {el.title}
                    </li>
                  ))}
                </ul>
              </nav>
            </Grid>

            <Grid item xs={12} sm={12} md={9} lg={9}>
              <div className="rti-panel">
                <RtiDescription type={this.state.link} />
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>
    );
  }
}

export default RtiContainer;
